import React from "react";
import { Checkbox, Button } from "antd";
import FileListModalRender from "./children/FileListModalRender";
import { ReactComponent as Empty } from "../../../../../assets/icons/empty.svg";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { GAPersonalHistoryLinkToPremium, GAPersonalHistoryToEditClick } from "../../../../../ga/personalCenter";
import urlMap from "../../../../../../../constants/url";
const HistoryRender = ({
  isEditing,
  editingChange,
  files,
  handleSelectAll,
  handleSelectClick,
  handleDelete,
  handleDownloadClick,
  selectGuidList,
  selectAll,
  subscription,
}) => {
  const { t } = useTranslation(["personalCenterHistory", "common"]);
  return (
    <div className="history">
      <div className="mb-1 top-title">
        <h4 className="fw-bold">
          <div>
            {t("title")}
            <Link to="/purchase" onClick={GAPersonalHistoryLinkToPremium}>
              <Button
                size="small"
                style={{ display: subscription && subscription.status && subscription.status == "Active" ? "none" : `inline-block` }}
              >
                {t("upgradeBtn")}
              </Button>
            </Link>
          </div>
        </h4>
        <div className="right-ctr">
          {!isEditing ? null : (
            <div className="select-box">
              <Checkbox
                checked={selectAll}
                indeterminate={!!selectGuidList.length && selectGuidList.length < files.length}
                disabled={false}
                onChange={handleSelectAll}
              >
                {t("selectAllBtn")}
              </Checkbox>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleDelete}>
                <rect width="32" height="32" rx="16" fill="#8372FF" fillOpacity="0.13" />
                <path d="M7 11H25" stroke="#8372FF" strokeWidth="1.5" />
                <path d="M10 11V23.5C10 24.3284 10.6716 25 11.5 25H20.5C21.3284 25 22 24.3284 22 23.5V11" stroke="#8372FF" strokeWidth="1.5" />
                <path d="M14 15V21" stroke="#8372FF" strokeWidth="1.5" />
                <path d="M18 15V21" stroke="#8372FF" strokeWidth="1.5" />
                <path d="M13 8H19" stroke="#8372FF" strokeWidth="1.5" />
              </svg>
            </div>
          )}
          <div onClick={() => editingChange(!isEditing)}>
            {!isEditing ? (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="#8372FF" fillOpacity="0.13" />
                <path
                  d="M20.8433 8.23728L24.7625 12.1565C24.8601 12.2541 24.8601 12.4124 24.7625 12.51L13.9046 23.3679C13.8594 23.4131 13.7987 23.4392 13.7348 23.441L9.70258 23.5541C9.55906 23.5581 9.44165 23.4407 9.44568 23.2972L9.55873 19.2649C9.56052 19.2011 9.58668 19.1403 9.63185 19.0952L20.4897 8.23728C20.5874 8.13965 20.7456 8.13965 20.8433 8.23728Z"
                  stroke="#8372FF"
                  strokeWidth="1.5"
                />
                <line x1="17.8507" y1="11.1448" x2="21.8617" y2="15.1348" stroke="#8372FF" strokeWidth="1.5" />
              </svg>
            ) : (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="#8372FF" fillOpacity="0.13" />
                <path d="M11 11L21 21" stroke="#8372FF" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M21 11L11 21" stroke="#8372FF" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
              </svg>
            )}
          </div>
        </div>
      </div>
      <p>{t("subTitle")}</p>
      {files.length > 0 ? (
        <FileListModalRender
          files={files}
          // fileListModal={this.props.fileListModal}
          handleSelectAll={handleSelectAll}
          handleSelectClick={handleSelectClick} //批量删除时选择文件
          handleDelete={handleDelete} //删除单个文件
          handleDownloadClick={handleDownloadClick} //下载单个文件
          selectGuidList={selectGuidList}
          isEditing={isEditing}
        />
      ) : (
        <div className="empty">
          <Empty />
          <p>
            <Trans i18nKey="personalCenterHistory:emptyTips">
              Text
              <a href={urlMap.get("editorPage")} className="ms-1" onClick={GAPersonalHistoryToEditClick}>
                Link
              </a>
            </Trans>
          </p>
        </div>
      )}
    </div>
  );
};

export default HistoryRender;
